/* eslint-disable max-len */
/**
 * English translations.
 */
export default {
  ACTION: {
    CANCEL: 'Cancel',
    CONFIRM: 'Confirm',
    SAVE: 'Save',
    SEARCH: 'Search'
  },
  ERROR: {},
  HEADER: {
    EMAIL: 'E-mail',
    END_DATE: 'End Date',
    MEMBER_ID: 'Member ID',
    NAME: 'Name'
  },
  LABEL: {
    ALLOW_ADD_MEMBERS: 'Allow adding partners',
    CREATE_MEMBER: 'Add member',
    DELETE_MEMBER_MODAL_TITLE: 'Delete member',
    EDIT_MEMBER: 'Edit Member',
    EMAIL: 'E-mail',
    END_DATE: 'End Date',
    MEMBERS: 'Members',
    NAME: 'Name',
    NO: 'No',
    YES: 'Yes'
  },
  SENTENCE: {
    DELETE_MEMBER_TEXT: 'Are you sure you want to delete the member?',
    NO_MEMBER_NAME_EMAIL: 'No name and/or no e-mail',
    NO_MEMBER_NAME_EMAIL_DETAIL: 'Please provide the name and/or e-mail',
    NO_ROWS_MEMBERS: 'No members',
    NO_ROWS_MEMBERS_DESCRIPTION: 'Please change your search criteria'
  },
  SUCCESS: {
    MEMBER_DELETED: 'Member was successfully deleted.',
    MEMBER_DETAILS_SAVED: 'Member was successfully saved.',
    SUCCESS: 'Success'
  },
  TOOLTIP: {
    EDIT_MEMBER: 'Edit Member',
    EMAIL: 'E-mail',
    END_DATE: 'End Date',
    MEMBER_ID: 'Member ID',
    NAME: 'Name',
    REMOVE_MEMBER: 'Remove Member'
  }
};
